import { computed } from 'vue';
import { PRODUCT_TYPES, FEATURE_FLAGS } from '@white-label-configuration/constants';
import { useTravelInsuranceStore } from '@white-label-store/travel-insurance';
import { getFeatureFlag } from '@white-label-plugin/launch-darkly';
import { getAppVariable } from '@white-label-helper/get-app-variable';

export function useTravelInsuranceAvailability() {
  const store = useTravelInsuranceStore();

  const isTravelInsuranceAvailable = computed(() => {
    if (!getFeatureFlag(FEATURE_FLAGS.EM_228_TRAVEL_INSURANCE)) return false;
    if (!store.isTravelInsuranceAvailableInMetadataOrConfig) return false;
    const staticProductCards = getAppVariable<{ product_type: string }[]>('static_product_cards') || [];
    return staticProductCards.some(card => card.product_type === PRODUCT_TYPES.TRAVEL_INSURANCE);
  });

  return { isTravelInsuranceAvailable };
}
